import React, { useState } from "react";
import { getCmsData } from "../../functions";
import HeaderSearchInput from "./header-search-input/HeaderSearchInput";

const Header = () => {
  const cmsData = getCmsData("headerDataCMS");
  if (!cmsData) return null;

  const { headerLinks } = cmsData;

  const [pageType, setPageType] = useState(
    document.getElementsByTagName("body")[0].classList.value
  );

  const logoStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    url: window.location.origin,
    logo: window.location.origin + require("../../images/agriculture-logo.svg"),
  };

  return (
    <header>
      <div className="container-fluid">
        <div className="controls-container col-lg-7 col-xl-8">
          <div className="hamburger-button-container col-sm-2 ">
            <button
              className="hamburger-button"
              type="submit"
              aria-label="Open Menu"
              tabIndex="0"
            ></button>
          </div>
          <div className="agriculture-logo-container col-sm-8 col-lg-12">
            <script type="application/ld+json">
              {JSON.stringify(logoStructuredData)}
            </script>
            {pageType == "animal-welfare" && (
              <a
                href="https://agriculture.vic.gov.au/livestock-and-animals/animal-welfare-victoria"
                aria-label="home"
              >
                <img
                  src={require("../../images/animal-welfare-logo.svg")}
                  className="animal-welfare-logo"
                  alt="Animal Welfare logo"
                />
              </a>
            )}
            {pageType != "animal-welfare" && (
              <a href="https://agriculture.vic.gov.au" aria-label="home">
                <img
                  src={require("../../images/agriculture-logo.svg")}
                  className="agriculture-logo"
                  alt="Agriculture logo"
                />
              </a>
            )}
            {pageType == "animal-welfare" && (
              <div className="agriculture-logo-branded-container ">
                <a href="https://agriculture.vic.gov.au" aria-label="home">
                  <img
                    src={require("../../images/agriculture-logo-dark.svg")}
                    className="agriculture-logo-dark"
                    alt="Agriculture logo"
                  />
                </a>
              </div>
            )}
          </div>
          <div className="search-button-container col-sm-2">
            <button
              className="search-button"
              type="submit"
              aria-label="Open Menu"
              tabIndex="0"
            ></button>
          </div>
        </div>
        <div className="header-search">
          <div className="link-group">
            {headerLinks.map((links, index) => (
              <a key={index} href={links.pageURL}>
                {links.pageName}
              </a>
            ))}
          </div>
          <HeaderSearchInput />
        </div>
      </div>
    </header>
  );
};

export default Header;
